export const FSep = String.fromCharCode(0xa4)
export const RSep = String.fromCharCode(0xae)
export const MSep = String.fromCharCode(0xb6)

const Tail = FSep + RSep + MSep

export enum MessageType {
  BROADCAST_QUEUE_STATS_EVENT = 1500,
  BROADCAST_QUEUE_AGENT_UPDATE = 2052,
  RESPONSE_EXTENSIONSTATE_EVENT = 1700,
  BROADCAST_HEARTBEAT_EVENT = 1705,
  RESPONSE_EXTENSIONLOCATION_EVENT = 1714,
  RESPONSE_CLIENT_EVENTS = 1721,
  ResponseGetLocation = 2048,
  BROADCAST_CALL_STATUS = 2057,
  BroadcastMediaItemsQueuHeld = 20573,
  BROADCAST_CALL_STATUS_TERMINATE = 2058,
  BROADCAST_STATIC_DIRECTORY_UPDATE = 2089,
  BROADCAST_QUEUE_AGENTSTATS = 2503,
  BROADCAST_WAITING_FOR_WRAPUP = 2543,
  RESPONSE_EXTENSIONAWAYFROMDESK_EVENT = 2544,
  RESPONSE_EXTENSIONTEMPLOGOUT_EVENT = 2545,
  RESPONSE_CH_UPDATE_EVENT = 2648,
  RESPONSE_CH_DELETE_EVENT = 2649,
  RESPONSE_MISCALLS_COUNT = 2650,
  BROADCAST_UPDATE_EXTENSION_DEFAULTDEVICEGROUP = 2679,
  BROADCAST_DB_UPDATE = 3541,
  RESPONSE_EXTENSIONSTATE_CALLBACK_EVENT = 17007,
  RESPONSE_STARTUP_VM_MC_TOASTER = 17301,
  BROADCAST_QUEUE_WARNING_POP_BROADCAST = 20521,
  BROADCAST_QUEUE_WARNING_BROADCAST = 20522,
  BROADCAST_VM_INBOXCOUNT = 25172,
  BROADCAST_VM_CLIENTPORT = 2615,
  REQUEST_COMMAND = 403,
  BROADCAST_CALL_NOTE_UPDATED = 2078,
  BroadcastAgentStats = 2750,
  BROADCAST_CALL_STATUS_TASKED = 20572,
  BROADCAST_CONNECTION_STATE = 2,
  BROADCAST_IM_CONVERSATIONJOIN = 29100,
  BROADCAST_IM_SWITCHTOCONVERSATIONUI = 29101,
  BROADCAST_IM_SETCONVERSATIONCHATHISTORY = 29102,
  BROADCAST_IM_CONVERSATIONCHATHISTORY = 29103,
  BROADCAST_IM_DISMISSCONVERSATION = 29104,
  BROADCAST_IM_RECIPIENTSTATUSUPDATED = 29105,
  BROADCAST_IM_NONURGENTMESSAGEBLOCKED = 29106,
  BROADCAST_IM_RECIPIENTSTOPPEDTYPING = 29108,
  BROADCAST_IM_RECIPIENTSTARTEDTYPING = 29109,
  BROADCAST_IM_RECIPIENTREMOVED = 29110,
  BROADCAST_IM_RECIPIENTADDED = 29112,
  BROADCAST_IM_CONVERSATIONTITLEUPDATED = 29113,
  BROADCAST_IM_CONVERSATIONMESSAGE = 29114,
  BROADCAST_IM_CONVERSATIONMESSAGEREPLACE = 29115,
  BROADCAST_IM_CONVERSATIONMESSAGEINSERTAFTER = 29116,
  BROADCAST_IM_ENDPOINTCONVERSATIONADDED = 29130,
  BROADCAST_IM_ENDPOINTCONVERSATIONUPDATED = 29131,
  BROADCAST_IM_ENDPOINTCONVERSATIONREMOVED = 29132,
  BROADCAST_IM_MARKCONVERSATIONASREAD = 29133,
  BROADCAST_IM_ONTOASTERPOP = 29134,
  BROADCAST_IM_SETTINGSCHANGED = 29141,
  BROADCAST_IM_ONUNREADCOUNT = 29142,
  BROADCAST_IM_CONVERSATIONUPDATED = 29143,
  REQUEST_EXTENSION_STARTUP_OPEN_CONVERSATIONS = 28010,
  REQUEST_IM_DEVICE_SEND_CONVERSATION_MESSAGE = 28002,
  REQUEST_IM_DEVICE_SET_CONVERSATIONSTATE = 28004,
  REQUEST_IM_JOINCONVERSATION = 29117,
  REQUEST_IM_DEVICEGETONETOONECONVERSATION = 28016,
  REQUEST_IM_REMOVECONVERSATION = 29118,
  REQUEST_IM_ADDPARTICIPANT = 29123,
  REQUEST_IM_REMOVEPARTICIPANT = 29124,
  REQUEST_IM_SENDINVITE = 29119,
  REQUEST_IM_SETBLOCKBTPRESENCE = 29120,
  REQUEST_IM_SETCONVERSATIONTITLE = 29121,
  REQUEST_IM_SETPARTICIPANTDETAILS = 29122,
  REQUEST_IM_CREATECONVERSATION = 29126,
  REQUEST_IM_SETDEFAULTDISPLAYNAME = 29127,
  REQUEST_IM_GETCONVERSATIONS = 29128,
  RESPONSE_IM_GETCONVERSATIONS = 29129,
  REQUEST_IM_REMOVESELF = 29135,
  REQUEST_IM_SETCONVERSATIONVIEW = 29136,
  REQUEST_IM_RESENDMESSAGE = 29139,
  REQUEST_IM_SETALLOWEMAIL = 29140,
  BroadcastShowPopUpBasic = 12123,
  BroadcastVmMessageCount = 1501,
  BROADCAST_VM_MSG_UPDATE = 2516,
  BROADCAST_VM_MSG_DELETE = 2518,

  BroadcastQueueExtensionRemove = 2661,

  NotifyParagraphTextChanged = 7531,
  NotifyTranscriptionStarted = 7513,
  NotifyTranscriptionStopped = 7514,
  NotifySubscriptionExpiring = 7515,

  NotifyParagraphSentimentScoreChanged  = 7530,
  NotifyDatastoreCallSentimentScoreChanged = 7534,

  BroadcastBookmarkCreated = 7602,
  BroadcastBookmarkDeleted = 7605,
  BroadcastBookmarkRenamed = 7608,
  BroadcastBookmarkMoved = 7611,

  //bookit 
  RequestOpenbookIt = 29150,
  ResponseOpenbookIt = 29151,
  TeamsClientControlExtensionCti = 30108,

  ResponseConference = 3506,

  //jitsi
  RequestJitsiJoin = 12165,
  ResponseJitsiJoin = 12166,

  //teams activity
  NotifyUpsertedActivity = 22967,
  NotifyDeletedActivity = 22968,
}

export enum ClientType {
  Client = 0,
  Teams = 17,
}

export function ucMessage(...args: any[]) {
  return args.join(FSep) + Tail
}

export function isTerminated(msg: string) {
  return msg.substr(-1) === MSep
}

export function parseUcMessages(message: string) {
  return ucSplit(message, MSep).map(msg =>
    ucSplit(msg, RSep).map(rec =>
      ucSplit(rec, FSep)))
}

function ucSplit(message: string, separator: string) {
  const res = message.split(separator)
  res.pop()
  return res
}

export function ucBool(value: string) {
  return value === '1'
}
